export default {
  '0': '草稿',
  '1': '审核中',
  '2': '审核通过',
  '3': '审核不通过',
}